import Config from '~domain/entities/Config/Config';

import { serviceNames } from '~setup/CartService';
import { diContainer } from '~setup/diContainer';

export const formatPriceWithCurrency = (price: number) => {
    const { config } = (diContainer.get(serviceNames.config) || {}) as Config;
    const priceFormatter = diContainer.get(serviceNames.priceFormatter) as Intl.NumberFormat;

    const {
        delimiter = '.',
        separator = ',',
        symbol_on_right = false,
        symbol_space = false
    } = config.currencyFormat || {};

    const sign = price < 0 ? '-' : '';
    const absolutePrice = Math.abs(price);
    const formatParts = priceFormatter.formatToParts(absolutePrice);
    const formattedPrice = formatParts.map(({ type, value }) =>
        type === 'group' ? separator : type === 'decimal' ? delimiter : value
    );

    const isCurrencyLeft = formatParts[0].type === 'currency';
    let currencySymbol = '';
    let currencySymbolOnRight = '';
    let currencySymbolOnLeft = '';

    currencySymbol = isCurrencyLeft ? formattedPrice.shift() || '' : formattedPrice.pop() || '';

    if (symbol_on_right) {
        currencySymbolOnRight = !!symbol_space ? ` ${currencySymbol}` : currencySymbol;
    } else {
        currencySymbolOnLeft = !!symbol_space ? `${currencySymbol} ` : currencySymbol;
    }

    try {
        const trimFormattedPrice = formattedPrice.join('').replace(/\s/g, '');

        return `${sign}${currencySymbolOnLeft}${trimFormattedPrice}${currencySymbolOnRight}`;
    } catch (error) {
        console.warn('Invalid price to format: ', { error, price });

        return '';
    }
};
